import Swiper from 'swiper'
import { A11y, Pagination } from 'swiper/modules';

import 'swiper/css/pagination'

let swiperInstance = false

Swiper.use([A11y, Pagination])

const mediaQuery = window.matchMedia('(max-width:64em)')

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-pillars-slider]')) {
            swiperInstance = new Swiper('[data-pillars-slider]', {
                slidesPerView: 1.5,
                spaceBetween: 32,
                centeredSlides: true,
                breakpoints: {
                    450: {
                        slidesPerView: 2,
                        spaceBetween: 64
                    },
                    700: {
                        slidesPerView: 3
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                }
            })

            // Removing within the slider init function does not work, we need to set a timeout to remove unnecessary aria attrs
            setTimeout(() => {
                const ariaLabelEls = document.querySelectorAll('.swiper [aria-label]')
                const ariaRoleEls = document.querySelectorAll('.swiper [role]')
                removeAriaAttr(ariaLabelEls, 'aria-label')
                removeAriaAttr(ariaRoleEls, 'role')
            }, 500)

            // Remove unnecessary aria attributes
            function removeAriaAttr (els, attr) {
                els.forEach(el => {
                    el.removeAttribute(attr)
                    el.setAttribute('aria-hidden', 'false')
                })
            }

            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)
